export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球顶级足球赛事资讯，涵盖英超、西甲、欧冠、世界杯等各大联赛最新动态、赛程与深度分析',
    articleCount: 48,
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等全球篮球赛事全覆盖，实时比分、赛程数据与专业解读',
    articleCount: 36,
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-trophy-line',
    description: '四大满贯赛事、ATP/WTA巡回赛最新战报，网球明星动态与专业分析',
    articleCount: 24,
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: '英雄联盟、DOTA2、CS:GO等顶级电竞赛事资讯，战队动态与赛事直播',
    articleCount: 32,
  },
  {
    slug: 'comprehensive',
    name: '综合体育',
    icon: 'ri-medal-line',
    description: '乒乓球、羽毛球、田径、游泳、赛车等综合体育项目赛事资讯与精彩回顾',
    articleCount: 20,
  },
];